import React, {Component} from 'react';
import XLSX from 'xlsx';
import {saveAs} from 'file-saver';
import moment from "moment";

class ExcelData extends Component {

    componentDidMount() {
        this.createExcel();
    }

    prepareTable(leads_list) {
        let html_str = '';

        html_str = '<html><table size="small" aria-label="dense table" id="lead_listing">' +
            '<thead>' +
                '<tr>' +
                    '<td align="left"></td>' +
                    '<td align="left"></td>' +
                    '<td align="left"></td>' +
                    '<td align="left"></td>' +
                    '<td align="left"></td>' +
                    '<td align="left"></td>' +
                    '<td align="center" colspan="3">Jahresplanung ' + this.props.year + '</td>' +
                    '<td align="center" colspan="2">Real/Ist ' + this.props.year + '</td>' +
                    '<td align="center" colspan="2">Lead 1</td>' +
                    '<td align="center" colspan="2">Lead 2</td>' +
                    '<td align="center" colspan="2">Lead 3</td>' +
                    '<td align="left"></td>' +
                '</tr>' +
                '<tr>' +
                    '<td align="left" width="7%">Proj.Nr.</td>' +
                    '<td align="left" width="12%">Kunde</td>' +
                    '<td align="left" width="12%">Projektname</td>' +
                    '<td align="left" width="12%">Branche</td>' +
                    '<td align="left" width="12%">Thema</td>' +
                    '<td align="left" width="12%">Einstufung</td>' +
                    '<td align="right" width="10%">%</td>' +
                    '<td align="left" width="10%">Plan II</td>' +
                    '<td align="left" width="10%">Plan III</td>' +
                    '<td align="left" width="7%">NK</td>' +
                    '<td align="left" width="7%">Honorar</td>' +
                    '<td align="left" width="5%">Name</td>' +
                    '<td align="right" width="2%">%</td>' +
                    '<td align="left" width="5%">Name</td>' +
                    '<td align="right" width="2%">%</td>' +
                    '<td align="left" width="5%">Name</td>' +
                    '<td align="right" width="2%">%</td>' +
                    '<td align="left">Kommentar</td>' +
                '</tr>' +
            '</thead>' +
            '<tbody>';

        Object.keys(leads_list.leads).map((key, index) => {
            leads_list.leads[key].map((h, index) => {
                let projectno = h.projectno === null ? "" : h.projectno;
                let leadplan_probability = h.leadplan_probability === undefined ? "" : parseInt(h.leadplan_probability, 10).toLocaleString('de-DE');
                let leadplan_plan2 = h.leadplan_plan2 === 0 || h.leadplan_plan2 === 0.0 || h.leadplan_plan2 === null ? "" : parseInt(h.leadplan_plan2, 10).toLocaleString('de-DE');
                let leadplan_plan3 = h.leadplan_plan3 === 0 || h.leadplan_plan3 === 0.0 || h.leadplan_plan3 === null ? "" : parseInt(h.leadplan_plan3, 10).toLocaleString('de-DE');
                let nk = h.nk === 0 || h.nk === 0.0 || h.nk === null ? "" : parseInt(h.nk, 10).toLocaleString('de-DE');
                let honorar = h.honorar === 0 || h.honorar === 0.0 || h.honorar === null ? "" : parseInt(h.honorar, 10).toLocaleString('de-DE');
                let lead1name = h.lead1name === null ? "" : h.lead1name;
                let lead1percent = h.lead1percent === 0 || h.lead1percent === 0.0 || h.lead1percent === null ? "" : h.lead1percent;
                let lead2name = h.lead2name === null ? "" : h.lead2name;
                let lead2percent = h.lead2percent === 0 || h.lead2percent === 0.0 || h.lead2percent === null ? "" : h.lead2percent;
                let lead3name = h.lead3name === null ? "" : h.lead3name;
                let lead3percent = h.lead3percent === 0 || h.lead3percent === 0.0 || h.lead3percent === null ? "" : h.lead3percent;
                if (index < leads_list.leads[key].length - 1) {
                    html_str += '<tr>' +
                        '<td align="left">' + projectno + '</td>' +
                        '<td align="left">' + h.customername + '</td>' +
                        '<td align="left">' + h.projectname + '</td>' +
                        '<td align="left">' + h.branch + '</td>' +
                        '<td align="left">' + h.theme + '</td>' +
                        '<td align="left">' + h.classification + '</td>' +
                        '<td align="right">' + leadplan_probability + '</td>' +
                        '<td align="right">' + leadplan_plan2 + '</td>' +
                        '<td align="right">' + leadplan_plan3 + '</td>' +
                        '<td align="right">' + nk + '</td>' +
                        '<td align="right">' + honorar + '</td>' +
                        '<td align="left">' + lead1name + '</td>' +
                        '<td align="right">' + lead1percent + '</td>' +
                        '<td align="left">' + lead2name + '</td>' +
                        '<td align="right">' + lead2percent + '</td>' +
                        '<td align="left">' + lead3name + '</td>' +
                        '<td align="right">' + lead3percent + '</td>' +
                        '<td align="left">' + h.comment + '</td>' +
                    '</tr>';
                } else {
                    html_str += '<tr>' +
                        '<td align="left" colspan="6">' + key + '</td>' +
                        '<td align="right">' + leadplan_probability + '</td>' +
                        '<td align="right">' + leadplan_plan2 + '</td>' +
                        '<td align="right">' + leadplan_plan3 + '</td>' +
                        '<td align="right">' + nk + '</td>' +
                        '<td align="right">' + honorar + '</td>' +
                        '<td align="right"></td>' +
                        '<td align="left"></td>' +
                        '<td align="left"></td>' +
                        '<td align="left"></td>' +
                        '<td align="left"></td>' +
                        '<td align="left"></td>' +
                        '<td align="left"></td>' +
                    '</tr>';
                }
            })
        })

        html_str += '<tr>' +
                '<td align="left" colspan="6">Summe</td>' +
                '<td align="right"></td>' +
                '<td align="right">' + parseInt(leads_list.summary.leadplan_plan2, 10).toLocaleString('de-DE')  + '</td>' +
                '<td align="right">' + parseInt(leads_list.summary.leadplan_plan3, 10).toLocaleString('de-DE')  + '</td>' +
                '<td align="right">' + parseInt(leads_list.summary.nk, 10).toLocaleString('de-DE')  + '</td>' +
                '<td align="right">' + parseInt(leads_list.summary.honorar, 10).toLocaleString('de-DE')  + '</td>' +
                '<td align="left"></td>' +
                '<td align="left"></td>' +
                '<td align="left"></td>' +
                '<td align="left"></td>' +
                '<td align="left"></td>' +
                '<td align="left"></td>' +
                '<td align="left"></td>' +
            '</tr>' +
        '</tbody>' +
    '</table></html>';

        return html_str;
    }

    stringToArray(s) {
        let buf = new ArrayBuffer(s.length);
        let view = new Uint8Array(buf);
        for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }

    createExcel = () => {
        let blob, wb = {SheetNames: [], Sheets: {}};
        let ws = XLSX.read(this.prepareTable(this.props.leads_list), {type: "string", raw: true}).Sheets.Sheet1;
        wb.SheetNames.push("Sheet1");
        wb.Sheets["Sheet1"] = ws;

        blob = new Blob([this.stringToArray(XLSX.write(wb, {bookType: 'xlsx', bookSST: false, type: 'binary'}))], {
            type: "application/octet-stream"
        });

        saveAs(blob, 'Akquise-' + moment().format('YYYY') + "-" + moment().format("YYYY-MM-DD") + ".xlsx");
    }

    render() {
        return null;
    }
}

export default ExcelData;